import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_findmoney.png",
      alt: "Estratégias FindMoney",
    },
    title: "Automatize suas operações na bolsa de valores com a FINDMONEY ™",

    // String ou array de strings
    text: [
      "Fundada em 2019, a FindMoney ™ é uma empresa de tecnologia em investimentos automatizados na bolsa de valores. Conta em sua equipe com desenvolvedores, investidores e estrategistas experientes que efetivamente entregam resultado priorizando segurança e gerenciamento de risco!",
      "Venha operar com a FINDMONEY ™",
    ],
    // testimonial: {
    //   text: "Nossa Prioridade é estar em constante evolução dos nossos produtos.",
    //   author: {
    //     name: "Mauro Martins, estrategista chefe da FindMoney ™",
    //     // picture:
    //     //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
    //   },
    // },
  },

  strategies: {
    title: "Estratégias FINDMONEY ™",
    heading:
      "Estratégias testadas e validadas e com expectativa matemática positiva.",
    subtitle:
      "Priorize o crescimento linear de seu capital com gerenciamento de risco",
  },

  cta: {
    title: "Pronto para obter ganhos consistentes com segurança?",
    subtitle: "Ative agora mesmo a extensão FINDMONEY ™",
    // buttonText:""
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "FindMoney ™",
    col1: [
      "Fundada em 2019, a FindMoney ™ é uma empresa de tecnologia em investimentos automatizado na bolsa de valores. Conta com investidores e estrategistas experientes que efetivamente entregam resultado e gerenciamento de risco!",
      "Venha operar com a FINDMONEY ™",
    ],
    // col2: [
    //   "É com esta premissa que estamos sempre buscando desenvolver os melhores algoritmos, prestando o melhor atendimento, excelentes ferramentas e funcionalidades que fazem da TraderBot o destaque no uso de estratégias automatizadas.",
    // ],
  },

  stats: {
    title: "Números da FINDMONEY ™",
    subtitle: "Segurança, consistência e transparência com os clientes",
    data: [
      {
        value: "+150",
        description: "Clientes satisfeitos",
      },
      {
        value: "+100",
        description: "Estratégias validadas",
      },
      {
        value: "+3",
        description: "Carteiras em operação",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Porque utilizar os robôs da FINDMONEY ™?",
    // subtitle: "Veja quais as principais vantagens dos robôs da TraderBot.",
    data: [
      {
        icon: iconsSet.money_off,
        title: "Período de teste",
        description: "Período de teste gratuito com a assessoria BRA/BS",
      },
      {
        icon: iconsSet.settings,
        title: "Automatização",
        description: "Estratégias 100% automatizadas, testadas e validadas",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte",
        description:
          "Suporte individual e em grupo, contato e proximidade com os estrategistas",
      },
      {
        icon: iconsSet.lock_line,
        title: "Segurança",
        description:
          "Prioridade no gerenciamento de risco e crescimento saudável do capital",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description: "Elimine o emocional de suas operações",
      },
      {
        icon: iconsSet.clock,
        title: "Tempo livre",
        description: "Tenha mais tempo para sua família",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Opero com a FindMoney a mais de 1 ano e as ferramentas e estratégias disponibilizadas são extremamente seguras e consistentes ou que me dá segurança para investir meu capital, sem contar a transparência do suporte e os ensinamentos transferidos pela equipe de estrategistas",
      author: "Marcelo F. Leite",
      job: "Advogado, trader e investidor",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "A FindMoney ™ é a melhor casa de robôs que encontrei, estratégias testadas e validadas com prioridade para o gerenciamento de risco, o que dá tranquilidade para operar e obter uma boa renda e aumentar do meu capital",
      author: "Guilherme Andreu",
      job: "Estudante",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
